<template>
  <div
    class="layout--main"
    :class="[navbarClasses, footerClasses, { 'app-page': isAppPage }, `sidebarWidth-${sidebarWidth}`]">
    <!--<vx-tour :steps="steps" v-if="!disableThemeTour" />-->

    <!--        <the-customizer-->
    <!--            @updateNavbar="updateNavbar"-->
    <!--            @updateNavbarColor="updateNavbarColor"-->
    <!--            @updateTheme="updateTheme"-->
    <!--            :navbarType="navbarType"-->
    <!--            :navbarColor="navbarColor"-->
    <!--            :footerType="footerType"-->
    <!--            @updateFooter="updateFooter"-->
    <!--            :routerTransition="routerTransition"-->
    <!--            @updateRouterTransition="updateRouterTransition"-->
    <!--            v-if="!disableCustomizer"-->
    <!--            :hideScrollToTop="hideScrollToTop"-->
    <!--            @toggleHideScrollToTop="toggleHideScrollToTop"-->
    <!--            />-->
    <vx-sidebar :sidebarItems="sidebarItems" :logo="require('@/assets/images/logo-sidebar.png')" parent=".layout--main" />
    
    <!-- Fixed Top Navbar -->
    <top-navbar />

    <div
      id="content-area"
      :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]">
      <div id="content-overlay"></div>

      <div class="content-wrapper">
        <!-- Navbar disabled, using sidebar instead -->
        <!--<the-navbar
          @validateData="validateData()"
          :navbarColor="navbarColor"
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark },
          ]" />-->

        <div class="router-view">
          <div
            class="router-content"
            :class="{ 'mt-0': navbarType == 'hidden' }">
            <transition :name="routerTransition">
              <div
                class="router-header flex flex-wrap items-center justify-between mb-6 bg-white shadow-sm rounded-lg p-4"
                v-if="
                  ($route.meta.breadcrumb || $route.meta.pageTitle) &&
                  $route.meta.pageTitle != 'Dashboard'
                ">
                <div class="content-area__heading">
                  <h2 class="mb-1 text-xl font-semibold text-gray-800">{{ $t(routeTitle) }}</h2>
                  <vx-breadcrumb v-if="$route.meta.breadcrumb" />
                </div>
                
                <!-- User actions or additional controls can go here -->
                <div class="flex items-center space-x-3">
                  <!-- Example: User dropdown or settings -->
                </div>
              </div>
            </transition>
            <div class="content-area__content">
              <back-to-top
                bottom="5%"
                visibleoffset="500"
                v-if="!hideScrollToTop">
                <vs-button
                  icon-pack="feather"
                  icon="icon-arrow-up"
                  class="shadow-lg" />
              </back-to-top>
              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle"></router-view>
              </transition>
            </div>
          </div>
        </div>
      </div>

      <!-- <the-footer></the-footer> -->
    </div>
  </div>
</template>

<script>
import VxSidebar from '@/layouts/components/vx-sidebar/VxSidebar.vue'
import TheCustomizer from '../components/customizer/TheCustomizer.vue'
import TheNavbar from '../components/TheNavbar.vue'
import TheFooter from '../components/TheFooter.vue'
import TopNavbar from '../components/TopNavbar.vue'
import themeConfig from '@/../themeConfig.js'
import defaultSidebarItems from '@/layouts/components/vx-sidebar/sidebarItems.js'
import BackToTop from 'vue-backtotop'

const VxTour = () => import('@/components/VxTour.vue')
import * as REPO from '../../repository/index'
import * as moment from 'moment'
import firebase from 'firebase/app'
import 'firebase/database'

const collectAllowedUrls = (items, urls = new Set()) => {
  items.forEach((item) => {
    if (item && item.url) urls.add(item.url)
    if (item && Array.isArray(item.submenu) && item.submenu.length) {
      collectAllowedUrls(item.submenu, urls)
    }
  })
  return urls
}

const allowedSidebarUrls = collectAllowedUrls(defaultSidebarItems)
const disallowedSidebarNames = new Set(['Vehicle Detail'])

export default {
  data() {
    return {
      navbarType: themeConfig.navbarType || 'static',
      navbarColor: themeConfig.navbarColor || '#fff',
      footerType: themeConfig.footerType || 'static',
      routerTransition: themeConfig.routerTransition || 'none',
      isNavbarDark: false,
      userFirebase: false,
      menu_parent: [],
      counterAlert: '',
      routeTitle: this.$route.meta.pageTitle,
      sidebarItems: [],
      disableCustomizer: themeConfig.disableCustomizer,
      waktuCek: null,
      windowWidth: window.innerWidth, //width of windows
      hideScrollToTop: themeConfig.hideScrollToTop,
      disableThemeTour: themeConfig.disableThemeTour,
      steps: [
        {
          target: '#btnSidebarToggler',
          content: 'Toggle Collapse Sidebar.',
        },
        {
          target: '.vx-navbar__starred-pages',
          content:
            'Create your own bookmarks. You can also re-arrange them using drag & drop.',
        },
        {
          target: '.i18n-locale',
          content: 'You can change language from here.',
        },
        {
          target: '.navbar-fuzzy-search',
          content: 'Try fuzzy search to visit pages in flash.',
        },
        {
          target: '.customizer-btn',
          content: 'Customize template based your preference',
          params: {
            placement: 'left',
          },
        },
      ],
    }
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle
      this.checkUserSession()
    },
    isThemeDark(val) {
      if (this.navbarColor == '#fff' && val) {
        this.updateNavbarColor('#10163a')
      } else {
        this.updateNavbarColor('#fff')
      }
    },
  },
  computed: {
    isAppPage() {
      if (this.$route.path.includes('/apps/')) return true
      else return false
    },
    isThemeDark() {
      return this.$store.state.theme == 'dark'
    },
    sidebarWidth() {
      return this.$store.state.sidebarWidth
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay
    },
    contentAreaClass() {
      if (this.sidebarWidth == 'default') return 'content-area-default'
      else if (this.sidebarWidth == 'reduced') return 'content-area-reduced'
      else if (this.sidebarWidth == 'no-sidebar') return 'content-area-full'
      else return 'content-area-default'
    },
    navbarClasses() {
      return {
        'navbar-hidden': this.navbarType == 'hidden',
        'navbar-sticky': this.navbarType == 'sticky',
        'navbar-static': this.navbarType == 'static',
        'navbar-floating': this.navbarType == 'floating',
      }
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType == 'hidden',
        'footer-sticky': this.footerType == 'sticky',
        'footer-static': this.footerType == 'static',
      }
    },
  },
  methods: {
    buildSidebarItems(masterMenu, roleMenus) {
      if (!Array.isArray(masterMenu) || !Array.isArray(roleMenus) || roleMenus.length === 0) {
        return []
      }

      const normalizeId = (value) => {
        if (value === undefined || value === null) return null
        const idString = String(value).trim()
        return idString.length ? idString : null
      }

      const normalizeParentId = (value) => {
        if (value === undefined || value === null) return null
        if (value === '') return ''
        const idString = String(value).trim()
        return idString.length ? idString : null
      }

      const allowedMenuIds = new Set()
      roleMenus.forEach((item) => {
        const normalized = normalizeId(item && item.menu_id)
        if (normalized) allowedMenuIds.add(normalized)
      })

      if (!allowedMenuIds.size) return []

      const nodeMap = new Map()

      masterMenu.forEach((menu) => {
        const menuId = normalizeId(menu && menu.id)
        if (!menuId) return

        const isExternal = this.isExternalLink(menu.menu_link)
        const parentId = normalizeParentId(menu && menu.parent_id)

        nodeMap.set(menuId, {
          id: menuId,
          url: menu.menu_link || null,
          name: menu.menu_name,
          slug: isExternal
            ? 'external'
            : menu.menu_link || menu.menu_name || menuId,
          icon: menu.menu_icon || 'CircleIcon',
          i18n: menu.menu_name,
          parent_id: parentId,
          __rootEmptyParent: menu && menu.parent_id === '',
          target: isExternal ? '_blank' : undefined,
          submenu: [],
        })
      })

      const includeIds = new Set()
      const resolveParent = (id) => {
        let currentId = id
        while (currentId && !includeIds.has(currentId)) {
          includeIds.add(currentId)
          const currentNode = nodeMap.get(currentId)
          currentId = currentNode && currentNode.parent_id ? currentNode.parent_id : null
        }
      }

      allowedMenuIds.forEach((id) => {
        if (nodeMap.has(id)) resolveParent(id)
      })

      const orderedRoots = []

      masterMenu.forEach((menu) => {
        const menuId = normalizeId(menu && menu.id)
        if (!menuId || !nodeMap.has(menuId)) return
        const node = nodeMap.get(menuId)
        if (!node || !includeIds.has(menuId)) return

        const hasParent =
          node.parent_id && includeIds.has(node.parent_id) && nodeMap.has(node.parent_id)

        if (hasParent) {
          const parentNode = nodeMap.get(node.parent_id)
          parentNode.submenu.push(node)
        }

        if (!hasParent && node.__rootEmptyParent && allowedMenuIds.has(node.id)) {
          orderedRoots.push(node)
        }
      })

      const pruneSubmenus = (items) => {
        return items.filter((item) => {
          if (disallowedSidebarNames.has(item.name)) {
            return false
          }

          // Filter out "HOME FICO" menu for FICO CLH and FICO roles
          const userInfo = JSON.parse(localStorage.getItem('userInfo') || 'null')
          const roleName = userInfo && userInfo.role && userInfo.role.role_name
          if ((roleName === 'FICO CLH' || roleName === 'FICO') &&
              (item.name === 'HOME FICO' || item.name === 'Home Fico' || item.name === 'Home FICO')) {
            return false
          }

          if (item.submenu && item.submenu.length) {
            item.submenu = pruneSubmenus(item.submenu)
          }

          if (!item.submenu || !item.submenu.length) {
            delete item.submenu
          }

          if (!item.target) delete item.target
          if ('__rootEmptyParent' in item) delete item.__rootEmptyParent

          if (!this.isAllowedSidebarUrl(item.url) && !item.submenu) {
            return false
          }

          return true
        })
      }

      return pruneSubmenus(orderedRoots)
    },
    isExternalLink(url) {
      if (!url || typeof url !== 'string') return false
      return /^https?:\/\//i.test(url)
    },
    isAllowedSidebarUrl(url) {
      if (!url) return true
      if (this.isExternalLink(url)) return true
      if (allowedSidebarUrls.has(url)) return true

      if (this.$router) {
        // Allow backend menus that map to registered internal routes
        const resolved = this.$router.resolve(url)
        if (
          resolved &&
          resolved.route &&
          Array.isArray(resolved.route.matched) &&
          resolved.route.matched.length
        ) {
          const isCatchAllOnly = resolved.route.matched.every(
            (record) => record.path === '*' || record.name === 'pageError404'
          )

          if (!isCatchAllOnly) return true
        }
      }

      return false
    },
    cloneSidebarItems(items) {
      return Array.isArray(items) ? JSON.parse(JSON.stringify(items)) : []
    },
    checkUserSession() {
      let self = this
      let user = JSON.parse(localStorage.getItem('userInfo'))
      if (user) {
        let param = {
          // Keep date filters to get all notifications from today (both read and unread)
          start_date: moment().format('YYYY-MM-DD') + ' 00:00:01',
          end_date: moment().format('YYYY-MM-DD') + ' 23:59:00',
          limit: 100,
          is_new: 0, // Change to 0 to get all notifications, not just new ones
          fleet_group_id: user.id,
        }
        REPO.getAlertHistoryNotification(param)
          .then((res) => {
            let data = res.data.data.data
            self.$store.dispatch('addNotifData', data)
            // Count only unread notifications for the badge counter
            let unreadCount = data.filter(notif => !notif.is_read).length
            self.$store.dispatch('updateCounter', unreadCount)
            self.$store.dispatch('notif/changeInitiate', true)
          })
          .catch((err) => {
            self.$vs.notify({
              duration: 5000,
              title: 'Error',
              text: 'User Session is Expired or someone is using this account on different device, Please Login Again',
              color: 'danger',
              position: 'bottom-right',
            })
            self.logout()
          })
      }
    },
    logout() {
      // let user_id = JSON.parse(localStorage.getItem('userInfo')).id
      // REPO.lgoutUser({ user_id }).then((res) => {
      // disconnect socket
      // socket.disconnect()
      // this.$auth.logOut()
      localStorage.removeItem('userInfo')
      localStorage.removeItem('userData')
      localStorage.removeItem('token')
      localStorage.removeItem('expired')
      this.$router.push('/pages/login')
      // Change role on logout. Same value as initialRole of acj.js
      // this.$acl.change('admin')
      localStorage.removeItem('userRole')
      // })
    },
    validateData() {
      let self = this
      let param = {
        // Keep date filters to get all notifications from today (both read and unread)
        start_date: moment().format('YYYY-MM-DD') + ' 00:00:01',
        end_date: moment().format('YYYY-MM-DD') + ' 23:59:00',
        limit: 100,
        is_new: 0, // Change to 0 to get all notifications, not just new ones
        fleet_group_id: self.$dataLocal.UserData().id,
      }
      REPO.getAlertHistoryNotification(param).then((res) => {
        let data = res.data.data.data

        self.$store.dispatch('addNotifData', data)
        // Count only unread notifications for the badge counter
        let unreadCount = data.filter(notif => !notif.is_read).length
        self.$store.dispatch('updateCounter', unreadCount)
        self.$store.dispatch('notif/changeInitiate', true)
      })
    },
    changeRouteTitle(title) {
      this.routeTitle = title
    },
    updateNavbar(val) {
      this.navbarType = val
      localStorage.setItem('navbar', val)
    },
    updateTheme(val) {
      localStorage.setItem('theme', val)
    },
    updateNavbarColor(val) {
      this.navbarColor = val
      if (val == '#fff') this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    updateFooter(val) {
      this.footerType = val
    },
    updateRouterTransition(val) {
      this.routerTransition = val
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth
      this.setSidebarWidth()
    },
    setSidebarWidth() {
      // REMOVED: Sidebar state management is now fully handled by VxSidebar component
      // This prevents duplicate/conflicting sidebar state updates
      // VxSidebar.vue handles all sidebar open/close/width logic including touch device detection

      // Only handle theme tour visibility based on screen size
      if (this.windowWidth < 768) {
        this.disableThemeTour = true
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val
    },
    signInFirebase() {
      firebase
        .auth()
        .signInAnonymously()
        .catch(function (error) {
          //
        })
    },
  },
  components: {
    VxSidebar,
    TheNavbar,
    TheFooter,
    TheCustomizer,
    TopNavbar,
    BackToTop,
    VxTour,
  },
  mounted() {
    var self = this
    this.checkUserSession()
    
    // Add window resize listener for responsive sidebar
    this.$nextTick(() => {
      window.addEventListener('resize', this.handleWindowResize)
    })
    
    var navb = localStorage.getItem('navbar')
    if (navb) {
      this.navbarType = navb
    }
    var themes = localStorage.getItem('theme')
    if (themes) {
      this.$store.dispatch('updateTheme', themes)
    }
    this.$root.$on('reloadNotifAtas', () => {
      //
      this.validateData()
    })
    REPO.getListMenu()
      .then((res) => {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') || 'null')
        const roleFromUser = userInfo && userInfo.role
        const roleMenus = roleFromUser && Array.isArray(roleFromUser.role_menu)
          ? roleFromUser.role_menu
          : []
        const masterMenu = res && res.data && Array.isArray(res.data.data) ? res.data.data : []

        const sidebarTree = this.buildSidebarItems(masterMenu, roleMenus)

        if (sidebarTree.length) {
          this.sidebarItems = sidebarTree
          this.menu_parent = this.cloneSidebarItems(sidebarTree)
        } else {
          const fallbackMenu = this.cloneSidebarItems(defaultSidebarItems)
          this.sidebarItems = fallbackMenu
          this.menu_parent = this.cloneSidebarItems(fallbackMenu)
        }
      })
      .catch(() => {
        const fallbackMenu = this.cloneSidebarItems(defaultSidebarItems)
        this.sidebarItems = fallbackMenu
        this.menu_parent = this.cloneSidebarItems(fallbackMenu)
      })
    firebase.auth().onAuthStateChanged(function (user) {
      //
      if (user) {
        //
        self.userFirebase = true
        //
        let ref = firebase
          .database()
          .ref('alert/' + self.$dataLocal.UserData().fleet_group_id)
        self.reff = ref
        ref.on(
          'value',
          function (snapshot) {
            let param = {
              start_date: moment().format('YYYY-MM-DD') + ' 00:00:01',
              end_date: moment().format('YYYY-MM-DD') + ' 23:59:00',
              limit: 10,
              is_new: 1,
              fleet_group_id: self.$dataLocal.UserData().id,
            }
            if (self.waktuCek == null) {
              //
              self.waktuCek = moment()
              REPO.getAlertHistoryNotification(param).then((res) => {
                let data = res.data.data.data

                self.$store.dispatch('addNotifData', data)
                self.$store.dispatch('updateCounter', res.data.data.total)
                self.$store.dispatch('notif/changeInitiate', true)
              })
            } else {
              let now = moment()
              let past = moment(self.waktuCek)
              let perbedaan = now.diff(past, 'seconds')
              //
              //

              if (Math.abs(parseInt(perbedaan)) > 60) {
                self.waktuCek = moment()
                //
                REPO.getAlertHistoryNotification(param).then((res) => {
                  let data = res.data.data.data

                  self.$store.dispatch('addNotifData', data)
                  self.$store.dispatch('updateCounter', res.data.data.total)
                  self.$store.dispatch('notif/changeInitiate', true)
                })
              }
            }

            // this.$store.dispatch('eCommerce/additemInCart', item)
            //
            let initiate = self.$store.getters['notif/isInitiate']()
            let allData = []
            // keys.forEach(x=>{
            //     let tmp = x.toString();
            //     // let check_ada = self.$store.getters['notif/isInAlertList'](tmp);
            //     // if(!check_ada){
            //     //     self.$store.dispatch('notif/addNotifNew',tmp);
            //     if(x!=='create_date')
            //         allData.push(data_firebase[x].body);
            //     // }
            //     // self.$store.dispatch('addCounter','1');
            //     // if(!check_ada && initiate){
            //     //     let license_plate = data_firebase[x].body.license_plate;
            //     //     let jenis_alert = data_firebase[x].body.alert;
            //     //     let jenis = 'danger';
            //     //     if(jenis_alert=='Over Speed'){
            //     //         jenis='danger';
            //     //     }else{
            //     //         jenis='warning';
            //     //     }
            //     //     let lokasi = data_firebase[x].body.lokasi;
            //     //
            //     //     self.$vs.notify({
            //     //         time: 5500,
            //     //         title: license_plate.toString(),
            //     //         text: "The Vehicle is "+jenis_alert.toString(),
            //     //         iconPack: 'feather',
            //     //         icon: 'icon-alert-circle',
            //     //         color: jenis,
            //     //         click:()=>{
            //     //             // self.$router.push('/monitoring-vehicle/'+license_plate);
            //     //             let win = window.open(lokasi, '_blank');
            //     //             win.focus();
            //     //         }
            //     //     });
            //     // }
            //
            // });
          },
          function (errorObject) {
            // ("The read failed: " + errorObject.code);
          }
        )
      } else {
        // User is signed out.
        // ...
        // ("sign out")
      }
      // ...
    })
    if (self.userFirebase) {
      let ref = firebase
        .database()
        .ref('tracking/' + this.$dataLocal.UserData().fleet_group_id)
      self.reff = ref
      ref.on(
        'value',
        function (snapshot) {
          //
          //
          //
        },
        function (errorObject) {
          //
        }
      )
    }
    this.signInFirebase()
  },
  created() {
    this.setSidebarWidth()
    if (this.navbarColor == '#fff' && this.isThemeDark) {
      this.updateNavbarColor('#10163a')
    } else {
      this.updateNavbarColor(this.navbarColor)
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize)
  },
}
</script>
